import { render, staticRenderFns } from "./SearchWelcome.vue?vue&type=template&id=8d12e536&scoped=true&"
import script from "./SearchWelcome.vue?vue&type=script&lang=js&"
export * from "./SearchWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d12e536",
  null
  
)

export default component.exports